import { GetQueryProps } from 'services/api/firestore';
import { DocumentData } from 'firebase/firestore';
import { Status } from 'shared/enums';
import { colors } from 'theme';
import { capitalize } from 'utilities';
import { Option } from 'shared/Components';

export const ARTIST_DEFAULT_PROFILE_ICON =
  'https://storage.googleapis.com/jigsaw-puzzle-universe-web.appspot.com/users/OPmpX0Y2CMQ0Vb68L6jiy9tyTqs1/profile?timestamp=1675446152535';

export const USERNAME_MAX_LENGTH = 50;
export const USERNAME_MIN_LENGTH = 8;

export const ARTIST_STATUS_DROPDOWN_ITEMS = [
  { label: capitalize(Status.Pending), value: Status.Pending },
  { label: capitalize(Status.Approved), value: Status.Approved },
  { label: capitalize(Status.Rejected), value: Status.Rejected },
  { label: capitalize(Status.Disabled), value: Status.Disabled },
  { label: capitalize(Status.New), value: Status.New },
];

export const ARTIST_STATUS_CONSTANTS = {
  [Status.Approved]: {
    style: {
      background: colors.green,
      color: colors.white,
    },
    label: Status.Approved,
  },
  [Status.Rejected]: {
    style: {
      backgroundColor: colors.red,
      color: colors.white,
    },
    label: Status.Rejected,
  },
  [Status.Deleted]: {
    style: {
      backgroundColor: colors.red,
      color: colors.white,
    },
    label: Status.Deleted,
  },
  [Status.Pending]: {
    style: {
      backgroundColor: colors.yellow,
      color: colors.white,
    },
    label: Status.Pending,
  },
  [Status.Processing]: {
    style: {
      backgroundColor: colors.yellow,
      color: colors.white,
    },
    label: Status.Processing,
  },
  [Status.Edited]: {
    style: {
      backgroundColor: colors.yellow,
      color: colors.white,
    },
    label: Status.Edited,
  },
  [Status.New]: {
    style: {
      backgroundColor: colors.purple,
      color: colors.white,
    },
    label: Status.New,
  },
  [Status.Disabled]: {
    style: {
      backgroundColor: colors.black,
      color: colors.white,
    },
    label: Status.Disabled,
  },
  [Status.None]: {
    style: {
      backgroundColor: colors.gray,
      color: colors.white,
    },
    label: Status.None,
  },
};

export const ARTIST_PUZZLE_COUNT_VALUES = {
  all: 'all',
  withPuzzles: 'withPuzzles',
  withoutPuzzles: 'withoutPuzzles',
} as const;

export const ARTIST_PUZZLE_COUNT_DROPDOWN_OPTIONS: Array<Option<string, string>> = [
  { value: ARTIST_PUZZLE_COUNT_VALUES.all, label: 'All' },
  { value: ARTIST_PUZZLE_COUNT_VALUES.withPuzzles, label: 'With puzzles' },
  { value: ARTIST_PUZZLE_COUNT_VALUES.withoutPuzzles, label: 'Without puzzles' },
];

export const ARTIST_SUSPENDED_DROPDOWN_OPTIONS: Array<Option<boolean | string, string>> = [
  { value: 'all', label: 'All' },
  { value: true, label: 'Yes' },
];
export const ARTISTS_COLLECTION_PATH = 'usersWeb';

const ARTISTS_MAIN_FILTER = {
  attribute: 'Role',
  operator: '==',
  value: 'artist',
} as const;

export const ALL_ARTISTS_QUERY: GetQueryProps<DocumentData> = {
  collectionPath: ARTISTS_COLLECTION_PATH,
  filters: [ARTISTS_MAIN_FILTER],
};

export const ONLY_APPROVED_ARTISTS_QUERY: GetQueryProps<DocumentData> = {
  collectionPath: ARTISTS_COLLECTION_PATH,
  filters: [
    ARTISTS_MAIN_FILTER,
    {
      attribute: 'status',
      operator: '==',
      value: 'approved',
    },
  ],
};

export const ONLY_ACTIVE_ARTISTS_QUERY: GetQueryProps<DocumentData> = {
  collectionPath: ARTISTS_COLLECTION_PATH,
  filters: [
    ARTISTS_MAIN_FILTER,
    {
      attribute: 'status',
      operator: '!=',
      value: 'disabled',
    },
  ],
};

export const GOTIVA_ARTIST_DOC_ID = 'qP2XioUIRxU876I2dPYL8HRNuQz2'; //On both Prod and Dev.
